export interface SingleResponse<T> {
  success: boolean;
  statusCode: number;
  data: T;
}

export type ListResponse<T> = SingleResponse<T[]>;

export interface PagingResponse<T> extends ListResponse<T> {
  pageSize: number;
  pageNumber: number;
  totalPages: number;
  totalRecords: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

export interface AzSearchResponse<T> {
  count?: number;
  actionToken?: string;
  value: T[];
}

export interface RequestOption<T = Paging> {
  paging?: T;
  sortBy?: string;
  filter?: Filter;
  getSortBy?: () => string;
}

export interface Paging {
  pageSize: number;
  pageNumber: number;
}

export type Filter = {
  [key: string]: string | number | Array<number | string> | boolean;
};

export interface AzPaging {
  pageSize: number;
  skipToken?: string;
  sortBy?: string;
}
